import { useEffect } from "react";

/**
 * Sets a <link rel="canonical" href="..."> in <head>.
 * Works reliably across React 19 / react-helmet-async issues with link tags.
 */
const useCanonical = (path) => {
  useEffect(() => {
    if (!path) return;
    const base = "https://wintrustsolutions.com";
    const href = path.startsWith("http") ? path : `${base}${path}`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = href;
  }, [path]);
};

export default useCanonical;
